export const title = 'Active users';

Number of unique users who opened the app at least once.
